@if (resetForm$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    <div class="login-ideapa mat-title">Scegli la tua password</div>
    <div>
      <ideapa-text-field
        [label]="'Password'"
        [controlType]="'password'"
        [ngrxFormControlState]="form.controls.newPassword"
        [errors]="form.controls.newPassword.errors | ngrxFormsErr"
        [shouldShowError]="form.controls.newPassword.isInvalid &&form.controls.newPassword.isSubmitted"
        >
      </ideapa-text-field>
    </div>
    <div>
      <ideapa-text-field
        [label]="'Conferma Password'"
        [controlType]="'password'"
        [ngrxFormControlState]="form.controls.confirmPassword"
        [errors]="form.controls.confirmPassword.errors | ngrxFormsErr"
        [shouldShowError]="form.controls.confirmPassword.isInvalid && form.controls.confirmPassword.isSubmitted"
        >
      </ideapa-text-field>
    </div>
    <div translate class="password-hint">
      La password deve essere lunga almeno 8 caratteri.<br />
      Deve contenere maiuscole e minuscole.<br />
      Deve contenere almeno un numero.<br />
      Deve contenere almeno un carattere speciale (!&#64;#$%^&*_-).
    </div>
    <div class="mt-3 text-end">
      <ideapa-button
        type="submit"
        [cssClasses]="'btn-primary'"
        [text]="'Reset password'"
      ></ideapa-button>
    </div>
  </form>
}
@if (authError$ | ngrxPush; as authError) {
  <div
    class="login-error text-error text-right mt-3"
    >
    {{ authError }}
    <br />
    <br />
    <yam-ui-button
      (click)="resetAuthError()"
      [routerLink]="['/auth/login']"
      buttonType="button"
      color="primary"
      >Torna al login
    </yam-ui-button>
    <!-- <a
    [routerLink]="['/auth/forgot-password']"
    translate
    class="forgot-link"
    translate
    >Try again</a
    > -->
  </div>
}
